import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { basePageWrap } from '../BasePage';
import styles from './ObjectPage.module.scss';

import i18n from '../../i18n';
import ArticleEntry from '../../components/ArticleEntry';
import RichText from '../../components/RichText';
import InfoBox from '../../components/InfoBox';
import Picture from '../../components/Picture';
import GuideList from '../../components/GuideList';
import GuideTeaser from '../../components/GuideTeaser';
import MassInfo from '../../components/MassInfo';

class ObjectPage extends PureComponent {
    state = {};

    static propTypes = {
        featuredImage: PropTypes.object,
        articleEntry: PropTypes.shape(ArticleEntry.propTypes),
        richText: PropTypes.shape(RichText.propTypes),
        infoBox: PropTypes.shape(InfoBox.propTypes),
        infoBoxText: PropTypes.shape(InfoBox.propTypes),
        featuredGuides: PropTypes.array,
        relatedGuides: PropTypes.array,
        massInfo: PropTypes.array,
    };

    render() {
        const {
            featuredImage,
            articleEntry,
            richText,
            infoBox,
            infoBoxText,
            challenge,
            potential,
            solution,
            featuredGuides = [],
            relatedGuides = [],
            massInfo = [],
        } = this.props;

        return (
            <section className={styles['ObjectPage']}>
                <div
                    className={
                        styles['ObjectPage__Main'] +
                        ' ' +
                        styles['ObjectPage__Main--Grid']
                    }>
                    <section className={styles['ObjectPage__Section']}>
                        <ArticleEntry {...articleEntry} smallFonts={true} />
                    </section>

                    <section className={styles['ObjectPage__AsideWrapper']}>
                        <div className={styles['ObjectPage__Content']}>
                            {featuredImage && (
                                <img
                                    className={styles['ObjectPage__Img']}
                                    src={featuredImage?.renditions?.large?.src}
                                />
                            )}
                            {false && (
                                <div
                                    className={
                                        styles['ObjectPage__FeaturedImage']
                                    }>
                                    <Picture
                                        className={
                                            styles['ObjectPage__FeaturedImage']
                                        }
                                        image={featuredImage}
                                        size="large"
                                        modifier="Contain"
                                        classNameBorderRadius={
                                            styles['ObjectPage__NoBorderRadius']
                                        }
                                        lazy={false}
                                    />
                                    {featuredImage.caption && (
                                        <figcaption
                                            className={
                                                styles[
                                                    'ObjectPage__FeaturedImage__Caption'
                                                ]
                                            }>
                                            {featuredImage.caption}
                                        </figcaption>
                                    )}
                                </div>
                            )}

                            {massInfo.map((info, i) => (
                                <MassInfo key={i} {...info} />
                            ))}
                            <RichText {...richText} modifier="Object" />
                            <RichText {...challenge} modifier="Object" />
                            <RichText {...solution} modifier="Object" />
                            <RichText {...potential} modifier="Object" />

                            <div className={styles['ObjectPage__Section']}>
                                {infoBox && <InfoBox {...infoBox} />}
                                {infoBoxText && <InfoBox {...infoBoxText} />}
                            </div>
                        </div>
                        <aside className={styles['ObjectPage__Aside']}>
                            {!!relatedGuides.length && (
                                <p className={styles['ObjectPage__AsideTitle']}>
                                    {i18n.t('Guides.relatedGuideTeaser')}
                                </p>
                            )}
                            <div className={styles['ObjectPage__GuideTeasers']}>
                                {relatedGuides.map((guide, index) => (
                                    <div
                                        key={index}
                                        className={
                                            styles[
                                                'ObjectPage__GuideTeaserWrapper'
                                            ]
                                        }>
                                        <GuideTeaser {...guide} />
                                    </div>
                                ))}
                            </div>
                        </aside>
                    </section>
                </div>

                {!!featuredGuides.length && (
                    <div className={styles['ObjectPage__FeaturedGuides']}>
                        <GuideList
                            items={featuredGuides}
                            title={i18n.t('Object.relatedGuides')}
                        />
                    </div>
                )}
            </section>
        );
    }
}

export default basePageWrap(ObjectPage);
